module.exports = __webpack_public_path__ + "images/screen-shots/observation-490fd8b42a775e975c1cef7bafc89040.png";